export default __webpack_public_path__ + "static/shopping-centre-7-be49bde10a83fcaf67f46156c04b1bc0.jpg";